import { Resources } from './resource';

class ResourceLoader {
    constructor(loadCb, type,isLoader,options={}) {
        this.loadCb = loadCb || null;
        this.type = type || null;
        this.isLoader=isLoader;
        const el =options.el||'xCanvas';
        const SW = options.w||750, SH = options.h||1218;
        //  如果阻止 webgl 使用 pixi.js-legacy  配置 forceCanvas:true,
    
        this.app = new PIXI.Application({ width: SW, height: SH, resolution: 1,transparent:true, view:document.getElementById(el)}); //pixi.js-legacy
        this.app.SW = SW;
        this.app.SH = SH;
        this.app.stage.interactive = true;
        this.onLoaded();
    }

    onLoaded() {
        let loader= PIXI.Loader.shared;
        loader.add(this.isLoader?[]:Resources[this.type]).load((...args)=>{
            this.loadCb(...args,this.app)
        })
    }

    getApp() {
        return this.app;
    }

    handleProgress(loader) {
        
    }

    static create(loadCallBack,type,isLoader,options) {
        return new ResourceLoader(loadCallBack,type,isLoader,options);
    }
}

export default ResourceLoader